import type { SVGProps } from "react";

/**
 * minus-small, remove, delete
 * @category Interface General
 */
export default function IconMinusSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path d='M6.75 12H17.25' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}
